/* import __COLOCATED_TEMPLATE__ from './grouped-dropdown.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';

interface DropdownItem {
  text: string;
  value?: string;
  isDisabled?: boolean;
  tooltip?: string;
  icon?: any; // Use any for icon to match ic-interface-icon's flexible type system
  onSelectItem?: () => void;
  shouldCloseDropdown?: boolean;
  showNewTag?: boolean;
  onTooltipClick?: (event: Event) => void;
}

interface DropdownGroup {
  heading?: string;
  items: DropdownItem[];
}

interface Signature {
  Args: {
    groupList: DropdownGroup[];
    onSelectItem?: (value: string) => void;
    class?: string;
    'data-test-add-question-dropdown'?: string;
    'data-test-add-questions-opener'?: string;
  };
  Blocks: {
    default: [pair: any];
  };
}

export default class GroupedDropdown extends Component<Signature> {
  // Export interfaces for type checking
  static DropdownItem = null;
  static DropdownGroup = null;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::Shared::GroupedDropdown': typeof GroupedDropdown;
    'ai-agent/playground/shared/grouped-dropdown': typeof GroupedDropdown;
  }
}
